import React from 'react';
import { formatPresenceDuration, PresenceSummaryZone } from '../../utils/presence';

const PresenceStatus: React.FC<{ zone: PresenceSummaryZone }> = ({ zone }) => {
  if (typeof zone.absent_now !== 'boolean') return <span>—</span>;
  return <span className={`presence-status presence-status--${zone.absent_now ? 'absent' : 'present'}`}>
    {zone.absent_now ? 'Отсутствует' : 'Присутствует'}
    {zone.absent_now && <span className="presence-status__duration">{typeof zone.absent_for_sec === 'number' ? formatPresenceDuration(zone.absent_for_sec) : 'Длительность неизвестна'}</span>}
  </span>;
};

export default PresenceStatus;
